import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Enfant } from '../devis-formulaire/Models/Enfant';
import { NiveauRemboursement } from '../devis-formulaire/Models/NiveauRemboursement';
import { Personne } from '../devis-formulaire/Models/Personne';

@Injectable({
  providedIn: 'root',
})
export class MyDataService {
  constructor() {}

  //Sharing data between Unrelated component:
  //Component 1 health-assuré-form
  //Component 2 formula-picker-b2c
  //For Transfert data Personne Model//

  public personneData = signal<Personne>(
    !!sessionStorage.getItem('app.personne')
      ? JSON.parse(sessionStorage.getItem('app.personne')!)
      : new Personne(
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          new Enfant(0, []),
          '',
          new NiveauRemboursement('', '', '', '', ''),
          '',
          '',
          '',
          false,
          localStorage.getItem('parrain') || '',
        ),
  );

  setPersonne(data: Personne) {
    this.personneData.set(data);
  }

  //For ControllistParam
  _value2!: any;
  private dataSource_healthModelStoredData = new BehaviorSubject<any>(
    this._value2,
  );
  currentData_healthModelStoredData: any =
    this.dataSource_healthModelStoredData.asObservable();

  changeData_in_healthModelStoredData(data: any) {
    this.dataSource_healthModelStoredData.next(data);
  }
}
